// Reusable polling service for async operations
export class PollingService {
  constructor(url, interval = 2000) {
    this.url = url
    this.interval = interval
    this.timerId = null
  }

  start(callback) {
    this.stop()
    this.timerId = setInterval(callback, this.interval)
    // Immediate check
    callback()
  }

  stop() {
    if (this.timerId) {
      clearInterval(this.timerId)
      this.timerId = null
    }
  }

  isRunning() {
    return this.timerId !== null
  }
}
